module.exports = __webpack_public_path__ + "media/2.39513f4f.wav";